import React from 'react';
import { stylesheet } from 'typestyle';
import { Red80 } from '@traceair/tds';
import { UploadData } from '../../../../store/uploadStore';

const css = stylesheet({
  container: {
    color: Red80,
  },
});

interface Props {
  interruptedUploads: UploadData[];
}

export const GlobalStatusInterrupted = ({ interruptedUploads }: Props) => {
  return (
    <div className={css.container}>
      {interruptedUploads.length === 1
        ? 'An incomplete upload found. '
        : `${interruptedUploads.length} incomplete uploads found. `}
      Please upload the missing files.
    </div>
  );
};
